import React, { useState } from 'react';
import { Link } from '@/shared/ui/link';
import { AvatarWrapper, ImageElement } from '../header/styles';
import { useCurrentLocale } from '@locales/client';
import { useUser } from '@/shared/providers/user-provider/use-user';
import { usePathname } from 'next/navigation';

interface AvatarProps {
  avatar?: string;
  width?: number;
  height?: number;
  avatarWrapperWidth?: number;
  avatarWrapperHeight?: number;
  className?: string;
  onClick?: () => void;
}

export const Avatar: React.FC<AvatarProps> = ({
  avatar,
  width = 32,
  height = 32,
  avatarWrapperWidth = 40,
  avatarWrapperHeight = 40,
  className,
  onClick,
}) => {
  const [avatarUrl, setAvatarUrl] = useState<string>(''); // avatar ||
  const locale = useCurrentLocale();
  const { refreshUser } = useUser();
  const pathname = usePathname();

  // TODO для лучших времен

  // useEffect(() => {
  //   if (avatar) {
  //     setAvatarUrl(avatar);
  //   }
  // }, [avatar]);

  const handleImageError = () => {
    setAvatarUrl('/images/icons/avatar-default-gray.svg');
  };

  const handleGameClick = (e: React.MouseEvent) => {
    const isProfilePage = pathname.includes('/ru/profile');
    if (isProfilePage) {
      e.preventDefault();
    }
  };

  return (
    <AvatarWrapper
      $width={avatarWrapperWidth}
      $height={avatarWrapperHeight}
      className={className}
      onClick={onClick}
    >
      <Link href={`/${locale}/profile`} onClick={(e) => handleGameClick(e)}>
        <ImageElement
          width={width}
          height={height}
          src={avatarUrl || '/images/icons/avatar-default-gray.svg'}
          alt="User avatar"
          onError={handleImageError}
          loading="lazy"
        />
      </Link>
    </AvatarWrapper>
  );
};
